import Import from "./Import";
import Export from "./Export";

const importExportComponents = {
  Import,
  Export,
}

export default importExportComponents